export default "__VITE_ASSET__D_CuV95S__"